export default __webpack_public_path__ + "static/media/blog-img239.84592a94.jpg";